export class DlsgPolicyPlan {
    'resourceTypes';
    'backupSchedule';
    'dlsgConfig';
    'vaultMetadataReplicationConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "backupSchedule",
            "baseName": "backupSchedule",
            "type": "HighFrequencyBackupSchedules",
            "format": ""
        },
        {
            "name": "dlsgConfig",
            "baseName": "dlsgConfig",
            "type": "Array<DlsgPolicyConfig>",
            "format": ""
        },
        {
            "name": "vaultMetadataReplicationConfig",
            "baseName": "vaultMetadataReplicationConfig",
            "type": "VaultMetadataReplicationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DlsgPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
